/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Company_Name_PlaceholderInputs */

const es_co2_signup_company_name_placeholder = /** @type {(inputs: Signup_Company_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mi Empresa S.A.S.`)
};

/**

* @param {Signup_Company_Name_PlaceholderInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const signup_company_name_placeholder = /** @type {((inputs?: Signup_Company_Name_PlaceholderInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Company_Name_PlaceholderInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_signup_company_name_placeholder(inputs)
});